import React, { useRef } from 'react'
import { node } from 'prop-types'
import { createStoreLocatorContext, StoreLocatorContext } from './context'

// eslint-disable-next-line import/prefer-default-export
export function StoreLocatorProvider({ children, ...props }) {
  const storeRef = useRef()
  if (!storeRef.current) {
    storeRef.current = createStoreLocatorContext(props)
  }
  return <StoreLocatorContext.Provider value={storeRef.current}>{children}</StoreLocatorContext.Provider>
}

StoreLocatorProvider.propTypes = {
  children: node,
}
